export const SUPPORT_CHAT_IFRAME_ID = "webchat"

// the host bootstraps the chat for every page, so pages that must not show it opt out by app key
export const APPS_WITHOUT_SUPPORT_CHAT: ReadonlyArray<string> = ["agent-workspace"]

export const SUPPORT_CHAT_COLOR = "blue"
export const SUPPORT_CHAT_WIDTH = "320"
export const SUPPORT_CHAT_HEIGHT = "600"
